import type { ScriptableScaleContext } from 'chart.js'

// Canvas can't read CSS custom properties, so the chart colours are the
// --wb-* token values (tokens.module.sass) or $wb-* palette values
// (_palette.sass) written out, plus chart-only tints with no token:
// criticalWord, greyBar, grid and zone.
export const COLOURS = {
  apricot: '#FCB88E',
  axis: '#DCE3D2',
  // A darker orange than --wb-orange, so critical words stay legible on the pale background.
  criticalWord: '#B6531B',
  forest: '#1E725B',
  forestDark: '#094F3D',
  forestDarker: '#06382B',
  forestFill: '#BDDBD2',
  forestLight: '#289779',
  greyBar: '#D6DDCB',
  grey200: '#D6D6D6',
  grey600: '#575757',
  grid: '#EEF2E8',
  ink: '#022302',
  lime: '#BDEC3F',
  orange: '#F97D31',
  white: '#FFFFFF',
  yellow: '#EFD212',
  zone: '#EEF7D6',
}

// The engagement chart's lines, one per channel: the --wb-channel-* tokens.
export const CHANNEL_COLOURS = {
  onboarded: '#094F3D',
  coaching: '#1E725B',
  workshops: '#2CA6D8',
  app: '#2C378A',
}

export const FONTS = {
  body: "'Open Sans', sans-serif",
  heading: "'Kanit', sans-serif",
}

export const AXIS_FONT = { family: FONTS.body, size: 12 }

// Month labels along the bottom, the latest one darker and bolder.
export const monthTicks = (count: number) => ({
  maxRotation: 0,
  color: (context: ScriptableScaleContext) => (context.index === count - 1 ? COLOURS.ink : COLOURS.grey600),
  font: (context: ScriptableScaleContext) => ({ ...AXIS_FONT, weight: context.index === count - 1 ? '600' : '400' }),
})

export const percentTick = (value: number | string): string => `${value}%`
